













































import { Vue, Component, Prop } from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class LogBody extends Vue {
  @Prop() readonly data!: any;

  @Prop() readonly current!: number;

  @Prop() readonly size!: number;

  utilsInstance = utils;
}
